const API_HOST = process.env.REACT_APP_API_HOST;
const HOME = process.env.REACT_APP_HOME;

export { API_HOST };
export { HOME };

export const BORDER_GREY = "#E8E9EC";
export const BUTTON_BORDER_RADIUS = "5px";
export const WHITE = "#FFFFFF";

export const COLORS = [
  "#55CBCF",
  "#37A1EA",
  "#FF6384",
  "#1E355C",
  "#FEC920",
  "#BCBCCB",
];

export const BOX_SHADOW = "5px 4px 30px rgba(0,0,0,.10)";
export const FORMAL_BOX_SHADOW = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
export const INNER_BOX_SHADOW =
  "rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset";
export const NAVBAR_BLUE = "#305697";
export const GREEN = "#4caf50";
export const KEYS_MAPPING = {
  Claims: "claims",
  "Amount Submitted": "amount",
  "Activity Amount Submitted": "activity_amount",
  "Paid Amount": "paid_amount",
  "Activity Paid Amount": "activity_paid_amount",
  "Denied Amount": "denied_amount",
  "Activity Denied Amount": "activity_denied_amount",
  Members: "members",
  Clinicians: "clinicians",
  "ICD1 Code": "icd1_codes",
  "ICD2 Code": "icd2_codes",
  "ICD3 Code": "icd3_codes",
  "ICD4 Code": "icd4_codes",
};

export const FUNCTION_MAPPING = {
  Count: "count",
  "Distinct Count": "distinctcount",
  Average: "average",
  Max: "max",
  Min: "min",
  Sum: "sum",
  // percentage:"Percentage"
};


export const OPP_FUNCTION_MAPPING = {
  count: "Count",
  distinctcount: "Distinct Count",
  average: "Average",
  max: "Max",
  min: "Min",
  sum: "Sum",
};

export const  OPP_KEYS_MAPPING = 
 {
  claims: "Claims",
  amount: "Amount Submitted",
  activity_amount: "Activity Amount Submitted",
  paid_amount: "Paid Amount",
  activity_paid_amount: "Activity Paid Amount",
  denied_amount: "Denied Amount",
  activity_denied_amount: "Activity Denied Amount",
  members: "Members",
  clinicians: "Clinicians",
  icd1_codes: "ICD1 Code",
  icd2_codes: "ICD2 Code",
  icd3_codes: "ICD3 Code",
  icd4_codes: "ICD4 Code",

};
